<template>
  <div class="footer">
    <div class="footer-content">
      <div class="logo">
        <router-link to="/" @click.native="toYjzl">
          <img src="/static/images/logo_yjzl.png" alt />
        </router-link>
        <p class="phone" v-if="!$global.isMobile">400-888-9725</p>
        <div class="qr-code" v-if="qrcode && !$global.isMobile">
          <img :src="qrcode" alt />
          <p>扫描二维码关注公众号</p>
        </div>
      </div>
      <ul class="foot-nav">
        <li v-for="(nav, i) in footNavList" :key="'foot_nav_' + i">
          <a class="foot-nav-cate" v-if="!nav.path">{{ nav.name }}</a>
          <a
            class="foot-nav-cate"
            :href="nav.path"
            target="_blank"
            v-else-if="nav.path.indexOf('http') > -1"
            >{{ nav.name }}</a
          >
          <router-link
            class="foot-nav-cate"
            :to="nav.path"
            @click.native="handleClickLink(item.path)"
            v-else
            >{{ nav.name }}</router-link
          >
          <ul class="foot-nav-children">
            <li
              v-for="(item, index) in nav.children"
              :key="'foot_nav_' + i + '_' + index"
            >
              <a
                :href="item.path"
                target="_blank"
                v-if="item.path.indexOf('http') > -1"
                >{{ item.name }}</a
              >
              <router-link
                :to="item.path"
                @click.native="handleClickLink(item.path)"
                v-else
                >{{ item.name }}</router-link
              >
            </li>
          </ul>
        </li>
      </ul>
      <div class="contact-wrap" v-if="$global.isMobile">
        <img class="qrcode" :src="mobileQrcode" alt="" />
        <p>扫描二维码关注亿景智联公众号</p>
        <p>400-888-9725</p>
      </div>
      <div class="copyright">
        <p>
          Copyright ©2020 changjing.com.cn Inc. All rights reserved |
          <a target="_blank" href="https://beian.miit.gov.cn/"
            >京ICP备20027634号-1</a
          >
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { checkHash } from "@/assets/javascript/utils";
const Hash = "https://www.changjing.com.cn";
export default {
  props: [],
  data() {
    return {
      footNavList: [
        {
          name: "产品服务",
          path: Hash + "/products",
          children: [
            {
              name: "亿景智图",
              path: "https://zt.changjing.com.cn",
              icon: "/static/images/products/product_dtwy.png",
              bg: "/static/images/products/product_dtwy_bg.png",
              info:
                "基于时空大数据的位置智能服务平台，是创新型企业级地理信息SaaS平台"
            },
            {
              name: "亿景排班",
              path: "https://pb.changjing.com.cn/",
              icon: "/static/images/products/product_wcpb.png",
              bg: "/static/images/products/product_wcpb_bg.png",
              info:
                "帮助企业提升客户拜访的效率，使业务人员可以服务更多的客户，扩大业务规模，赚取更多利润"
            },
            {
              name: "亿景知客",
              path: "https://zk.changjing.com.cn/",
              icon: "/static/images/products/product_wczk.png",
              bg: "/static/images/products/product_wczk_bg.png",
              info:
                "为企业进行客群分析，深度刻画用户画像，帮助企业定位目标客群，驱动企业高效实现客户增长，制定产品的销售策略。"
            },
            {
              name: "亿景选址",
              path: "https://xz.changjing.com.cn/",
              icon: "/static/images/products/product_wcyy.png",
              bg: "/static/images/products/product_wcyy_bg.png",
              info:
                "通过全面的客群和环境分析来解决店铺开在哪里的问题，减低选址的成本，提升店铺选址的成功率。"
            },
            {
              name: "亿景分单",
              path: "https://fd.changjing.com.cn/",
              info:
                "利用地理信息编码技术和范式星图丰富的地址库AI智能匹配技术帮助物流企业精准解析客户地址，快速分拣物流订单"
            },
            {
              name: "城市洞察",
              path: "https://dc.changjing.com.cn/",
              icon: "/static/images/products/product_csdc.png",
              bg: "/static/images/products/product_csdc_bg.png",
              info:
                "为城市管理者及各行各业提供大数据分析服务，对城市各领域进行多维度洞察与分析，实现产业洞察、智能规划、精准招商等功能"
            }
          ]
        },
        {
          name: "解决方案",
          children: [
            { name: "行业解决方案", path: Hash + "/solution/industry" },
            { name: "应用场景方案", path: Hash + "/solution/usercase" }
          ]
        },
        {
          name: "客户案例",
          path: Hash + "/client-case",
          children: [
            { name: "零售行业", path: Hash + "/client-case#retail" },
            { name: "地产行业", path: Hash + "/client-case#real_estate" },
            { name: "广告传媒", path: Hash + "/client-case#advertising_media" },
            {
              name: "金融保险",
              path: Hash + "/client-case#financial_insurance"
            },
            { name: "交通出行", path: Hash + "/client-case#transportation" },
            {
              name: "城市和政府",
              path: Hash + "/client-case#cities_government"
            },
            { name: "物流快递", path: Hash + "/client-case#express" }
          ]
        },
        {
          name: "关于我们",
          path: Hash + "/about-us",
          children: [
            { name: "公司介绍", path: Hash + "/about-us#introduce" },
            { name: "战略投资方", path: Hash + "/about-us#partner" },
            { name: "联系我们", path: Hash + "/about-us#contact" }
          ]
        },
        {
          name: "友情链接",
          children: [{ name: "秒影工场", path: "https://www.clipworks.com/" }]
        }
      ],
      qrcode: "/static/images/yj_qrcode.png",
      mobileQrcode: "/static/images/yj_mobile_qrcode.png"
    };
  },
  computed: {},
  created() {},
  methods: {
    handleClickLink(url) {
      let path = this.$route.path;
      let hash = this.$route.hash;
      let linkPath = url;
      let linkHash = "";
      let hashIndex = url.indexOf("#");
      if (hashIndex !== -1) {
        linkPath = url.substr(0, hashIndex);
        linkHash = url.substr(hashIndex);
      }
      if (path === linkPath && hash === linkHash) {
        checkHash(this);
      }
    },
    // 跳转亿景智联
    toYjzl() {
      window.open(Hash);
    }
  },
  mounted() {},
  components: {},
  destroyed() {}
};
</script>
<style lang="scss">
@import "../assets/stylesheets/config.scss";

.footer {
  width: 100%;
  background: #f9fbff;
  overflow: hidden;
  padding-left: 0;
  padding-right: 0;

  @include mediastyle(
    (
      height: 800px,
      font-size: 14px,
      padding-top: 120px,
      padding-bottom: 94px
    )
  );

  .footer-content {
    @include wrap_width;
    height: 100%;
    position: relative;
    overflow: hidden;

    .logo {
      float: left;
      text-align: center;
      @include mediastyle(
        (
          width: 210px
        )
      );
      img {
        width: 100%;
        height: 100%;
      }
    }

    .foot-nav {
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      position: absolute;
      right: 0;
      top: 0;
      @include mediastyle(
        (
          width: 800px,
          font-size: 16px
        )
      );

      a {
        font-size: 16px;
      }
      @media screen and (max-width: 1440px) {
        a {
          font-size: 14px;
        }
      }

      & > li {
        .foot-nav-cate {
          color: #333;
          font-weight: 600;
        }

        .foot-nav-children {
          @include mediastyle(
            (
              margin-top: 50px
            )
          );

          li {
            @include mediastyle(
              (
                line-height: 42px
              )
            );

            a {
              color: rgba(17, 17, 17, 0.5);
              transition: 0.3s;
              &:hover {
                color: #1e4b9f;
              }
            }
          }
        }
      }
    }

    .copyright {
      position: absolute;
      bottom: 0;
      color: rgba(17, 17, 17, 0.5);
      a {
        color: rgba(17, 17, 17, 0.5);
      }
      @include mediastyle(
        (
          right: 20px
        )
      );
    }

    .phone {
      font-weight: 800;
      color: #333333;
      @include mediastyle(
        (
          margin-top: 62px,
          font-size: 20px,
          line-height: 28px
        )
      );
    }

    .qr-code {
      margin: 0 auto;
      color: rgba(51, 51, 51, 0.5);
      @include mediastyle(
        (
          font-size: 14px,
          margin-top: 10px
        )
      );

      img {
        @include mediastyle(
          (
            width: 162px,
            height: 162px
          )
        );
      }
    }

    .contact {
      float: right;
      @include mediastyle(
        (
          margin-right: 60px,
          margin-top: 84px
        )
      );

      img {
        @include mediastyle(
          (
            width: 40px,
            height: 40px,
            margin-right: 40px
          )
        );
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .footer {
    height: auto;
    background: #f9fbff;
    padding-left: 0;
    padding-right: 0;
    padding-top: 6rem;

    .footer-content {
      height: 100%;
      position: relative;
      overflow: hidden;

      .logo {
        width: 100%;
        float: left;
        text-align: center;
        a {
          float: left;
        }
        img {
          width: 10rem;
        }
      }

      .foot-nav {
        width: 100%;
        float: left;
        overflow: hidden;
        display: block;
        position: static;
        margin-top: 4rem;

        & > li {
          float: left;
          width: 50% !important;
          padding-left: 1rem;
          margin-bottom: 4rem;
          a {
            font-size: 1.4rem;
          }
          &:nth-of-type(2n + 1) {
            clear: left;
          }
          .foot-nav-cate {
            color: #333;
            font-weight: 600;
          }

          .foot-nav-children {
            margin-top: 2.8rem;
          }
        }
      }

      .copyright {
        position: static;
        color: rgba(17, 17, 17, 0.5);
        margin-top: 4rem;
        float: left;
        font-size: 1.4rem;
        line-height: 1.7rem;
        a {
          color: rgba(17, 17, 17, 0.5);
        }
        @include mediastyle(
          (
            right: 20px
          )
        );
      }
      .contact-wrap {
        float: left;
        text-align: center;
        margin-top: 4rem;
        border-bottom: 1px solid rgba(238, 238, 238, 1);
        padding-bottom: 4rem;
        .qrcode {
          width: 70%;
        }
        p {
          height: 2rem;
          font-size: 1.4rem;
          color: rgba(17, 17, 17, 0.5);
          line-height: 2rem;
          margin-top: 0.9rem;
        }
      }

      .phone {
        font-weight: 800;
        color: #333333;
        @include mediastyle(
          (
            margin-top: 62px,
            font-size: 20px,
            line-height: 28px
          )
        );
      }

      .qr-code {
        margin: 0 auto;
        color: rgba(51, 51, 51, 0.5);
        @include mediastyle(
          (
            font-size: 14px,
            margin-top: 10px
          )
        );

        img {
          @include mediastyle(
            (
              width: 162px,
              height: 162px
            )
          );
        }
      }

      .contact {
        float: right;
        @include mediastyle(
          (
            margin-right: 60px,
            margin-top: 84px
          )
        );

        img {
          @include mediastyle(
            (
              width: 40px,
              height: 40px,
              margin-right: 40px
            )
          );
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue